import * as R from 'ramda';
import getUserAndClientsFromStorage from '../../utils/getUserAndClientsFromStorage';
import { sportsApiUrl } from '../../utils/apiUrls';

const { user: userFromStorage } = getUserAndClientsFromStorage();

const logout = store => async state => {
    try {
        const userId = state.user.id || null;
        const token = state.user.token || null;
        const clientId = state.user.selectedClientId;

        await fetch(`${sportsApiUrl}/logout`, {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-cache',
                'x-auth-token': token || userFromStorage.token,
                'x-client-id': clientId || userFromStorage.selectedClientId,
                'x-auth-user-id': userId || userFromStorage.id,
                'api-consumer-key': 'mvc',
            },
            credentials: 'include',
        });
        const loadingState = R.assoc('isLoading', true, state.user);
        store.setState({ user: loadingState });

        // clears session on localStorage
        localStorage.removeItem('mvc-user');
        store.setState(
            {
                user: {
                    isLoggedIn: false,
                    isLoading: false,
                    isSelectingClient: false,
                    selectedClientId: null,
                    selectedUserClientId: null,
                    error: null,
                    clients: [],
                },
                clients: {},
            },
            true,
        );
        location.reload();
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
    }
};

export default logout;
